<template>
  <div class="rewards-browser">
    <under-maintenance
      v-if="false"
      title="Work In Progress"
      firstLine="This Page is under Maintenance"
      secondLine="We are carrying out some improvements to the Reward Shop, this page will be available soon."
    />
    <loading-spinner v-else-if="loading" class="full-screen"/>
    <template v-else>

      <!-- Header -->
      <b-row class="mb-3">
        <b-col cols="12" md="6" lg="8">
          <h2 class="my-3">{{ $t('navigation.rewards') }}</h2>
        </b-col>
        <b-col cols="12" md="6" lg="4" class="d-flex flex-row justify-content-end align-items-start pt-2" v-if="isRecruiterAdmin">
          <b-btn class="mr-1" @click.prevent="() => selectedEditID = 'NEW'" variant="outline-primary">
            {{ $t('rewards.ctas.create-reward') }}
          </b-btn>
          <b-btn class="mr-1" variant="outline-primary" v-if="isRecruiterAdmin" v-b-modal.recruiterList>
            {{ $t('rewards.ctas.manage-claims') }} ({{ Array.isArray(manageClaimedRewards) ? manageClaimedRewards.length : 0 }})
          </b-btn>
        </b-col>
      </b-row>

      <!-- Token Balance & How to Earn Tokens -->
      <b-card class="d-block d-sm-none my-3" body-class="text-center" v-if="!(rewardScheme || rewardScores)">
        <b-card-title><strong>{{ $t('rewards.balance-title') }}</strong></b-card-title>
        <b-card-text>{{ rewardTokensBalance }} <rewards-coin/></b-card-text>
      </b-card>
      <template v-if="(rewardScheme || rewardScores)">
        <b-row>
          <b-col md="6" class="d-flex flex-column">
            <b-card class="mb-3" body-class="d-flex flex-column justify-content-center align-items-center">
              <div class="mb-2" style="font-size: 18px">{{ $t('rewards.total-balance') }}</div>
              <div class="d-flex justify-content-center align-items-end">
                <span style="font-size: 32px; line-height: 32px"><strong>{{rewardTokensBalance}}</strong></span>
                <span class="ml-2" style="font-size: 16px">{{ $t('rewards.tokens') }}</span>
              </div>
            </b-card>
            <how-to-earn-tokens-card
              :scores="rewardScores"
            />
          </b-col>
          <b-col md="6">
            <claimed-rewards-card
              :claimedRewards="claimedRewards"
              class="mb-3"
            />
            <reward-tokens-history-card
              :rewardTokensHistory="rewardTokensHistory"
            />
          </b-col>
        </b-row>
      </template>

      <!-- If Reward shop is not yet available -->
      <!-- <template v-if="isAssurant">
        <b-row class="my-5">
          <b-col cols="12" class="d-flex flex-column justify-content-center align-items-center my-3">
            <h3>Reward shop opening soon!</h3>
            <b-img fluid src="https://real-links-assets.s3-eu-west-2.amazonaws.com/assurant-K8e1Q/2023-03-29/01GWQSE2STMTFS126CX70KD1V9/assurant-monsters.png"/>
          </b-col>
        </b-row>
      </template> -->

      <!-- If Reward shop is available -->
      <b-row>
        <b-col cols="12" md="9" v-if="$apollo.queries.browseVouchers.loading || $apollo.queries.rewards.loading">
          <div class="d-flex justify-content-center align-items-center my-5">
            <b-spinner variant="primary"/>
          </div>
        </b-col>

        <b-col v-else-if="Array.isArray(browseVouchers) && xoxodayFilters && Array.isArray(rewards) && rewards.length">
          <b-tabs class="mt-3" align="center" pills>
            <b-tab title="rewards">
              <b-row class="my-3">
                <b-col class="mb-4" cols="12" sm="6" v-for="entry in rewards" :key="`reward-${entry.id}`">
                  <b-card class="h-100" body-class="p-0">
                    <b-media class="p-3">
                      <template v-slot:aside v-if="entry.image && typeof entry.image.fileLocation === 'string'">
                        <b-img v-if="entry.image.fileLocation.endsWith('.gif')" height="128" width="128"
                          :src="entry.image.fileLocation" :alt="entry.title"/>
                        <b-img v-else height="128" width="128"
                          :src="entry.image.fileLocation | cdn('resize', 128, 128)" :alt="entry.title"/>
                      </template>
                      <template v-slot:aside v-else>
                        <b-img blank blank-color="#ccc" height="128" width="128"/>
                      </template>
                      <b-card-body class="py-2 px-3">
                        <b-card-title>{{ entry.title }}</b-card-title>
                        <b-card-text>{{ entry.description }}</b-card-text>
                      </b-card-body>

                      <b-card-footer class="bg-white border-0 d-flex justify-content-end align-items-center">
                        <b-btn v-if="entry.url" :href="entry.url" target="_blank" variant="outline-primary" class="mr-3">
                          {{ $t('ctas.learn-more') }} <font-awesome-icon icon="external-link-alt" size="sm"/>
                        </b-btn>
                        <b-btn @click.prevent="() => selectedClaimID = entry.id" variant="primary"
                          :disabled="(canClaimRewards && canClaimThisReward(entry)) === false">
                            {{ entry.tokenCost }} <rewards-coin/>
                        </b-btn>
                      </b-card-footer>
                    </b-media>
                    <b-card-footer class="d-flex align-items-center" v-if="isRecruiterAdmin">
                      <b-btn @click.prevent="() => selectedEditID = entry.id" variant="link">{{ $t('ctas.pencil-edit') }}</b-btn>
                      <div class="flex-fill"/>
                      <i18n path="general.added" tag="span">
                        <template v-slot:timeAgo>{{ entry.createdAt | timeAgo }}</template>
                      </i18n>
                    </b-card-footer>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="vouchers" active>
              <b-row>
                <b-col cols="12" md="3" v-if="xoxodayFilters">
                  <b-form-group class="my-4" label="Search" label-for="whereSearch">
                    <b-input id="whereSearch" v-model="xoxodayWhere.productName"/>
                  </b-form-group>
                  <b-form-group class="my-4" label="Country" label-for="whereCountry">
                    <b-select id="whereCountry" :options="xoxodayCountryList" html-field="label" v-model="xoxodayWhere.country"/>
                  </b-form-group>
                  <b-form-group class="my-4" label="Category" label-for="voucherCategory">
                    <b-radio-group id="voucherCategory" stacked html-field="label"
                      :options="xoxodayVoucherCategoryList" v-model="xoxodayWhere.voucher_category"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="3" v-else/>
                <b-col cols="12" md="9" v-if="$apollo.queries.browseVouchers.loading || !browseVouchers">
                  <div class="d-flex justify-content-center align-items-center my-5">
                    <b-spinner variant="primary"/>
                  </div>
                </b-col>
                <b-col cols="12" md="9" v-else>
                  <b-row v-if="browseVouchers.length">
                    <b-col
                      v-for="voucher in browseVouchers
                        .slice((xoxodayPage - 1) * xoxodayLimit, xoxodayPage * xoxodayLimit)
                        .filter(({ customFields }) => customFields.currencyCode)"
                      :key="voucher.externalID" cols="12" sm="6" lg="4" xl="3"
                    >
                      <b-card class="my-4" no-body>
                        <b-card-img :src="voucher.imageURL" :alt="voucher.title" height="150px" class="img-fit-cover" top
                          v-b-modal="`modal-${voucher.externalID}`"/>
                        <b-card-body>
                          <b-card-title class="text-truncate" v-b-modal="`modal-${voucher.externalID}`">{{ voucher.title }}</b-card-title>
                          <choose-denominations v-if="voucher.customFields && voucher.customFields.valueDenominations" is-inline
                            :disabled="isDefaultIntegration"
                            :coin-balance="rewardTokensBalance"
                            :value-denominations="voucher.customFields.valueDenominations"
                            :exchangeRate="voucher.customFields.exchangeRate"
                            :currencyCode="voucher.customFields.currencyCode"
                            @claim="chosen => claimExternalReward(voucher, chosen)"/>
                        </b-card-body>
                      </b-card>
                      <b-modal :id="`modal-${voucher.externalID}`" :title="voucher.title" hide-footer size="xl">
                        <b-row>
                          <b-col cols="12" md="8">
                            <div class="d-flex justify-content-center align-items-center border border-radius">
                              <b-img class="border-radius my-5" :src="voucher.imageURL" :alt="voucher.title"
                                :style="{ 'max-height': '300px', width: '300px' }"/>
                            </div>
                            <b-card class="my-4" title="How to redeem/use" v-if="voucher.customFields && voucher.customFields.redemption">
                              <div class="rich-text-content" v-html="voucher.customFields.redemption"/>
                            </b-card>
                            <b-card class="my-4" title="Terms & Conditions" v-if="voucher.customFields && voucher.customFields.termsAndConditions">
                              <div class="rich-text-content" v-html="voucher.customFields.termsAndConditions"/>
                            </b-card>
                            <b-card class="my-4" :title="`About ${voucher.title}`" v-if="voucher.description">
                              <div class="rich-text-content" v-html="voucher.description"/>
                            </b-card>
                          </b-col>
                          <b-col cols="12" md="4">
                            <b-card bg-variant="light" v-if="voucher.customFields && voucher.customFields.deliveryType === 'delayed'" class="mb-3">
                              <h4>{{ $t('rewards.delay.title') }}</h4>
                              <p>{{ $t('rewards.delay.description') }}</p>
                            </b-card>
                            <b-card :title="voucher.title">
                              <choose-denominations v-if="voucher.customFields && voucher.customFields.valueDenominations"
                                :disabled="isDefaultIntegration"
                                :coin-balance="rewardTokensBalance"
                                :value-denominations="voucher.customFields.valueDenominations"
                                :exchangeRate="voucher.customFields.exchangeRate"
                                :currencyCode="voucher.customFields.currencyCode"
                                @claim="chosen => claimExternalReward(voucher, chosen)"/>
                            </b-card>
                          </b-col>
                        </b-row>
                      </b-modal>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-center align-items-center my-5" v-else>
                    <p>{{ $t('rewards.no-results') }}</p>
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <b-pagination v-model="xoxodayPage" :total-rows="browseVouchers.length" :per-page="xoxodayLimit"/>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>

        <template v-else-if="Array.isArray(browseVouchers) && xoxodayFilters">
          <b-col cols="12" md="3" v-if="xoxodayFilters">
            <b-form-group class="my-4" label="Search" label-for="whereSearch">
              <b-input id="whereSearch" v-model="xoxodayWhere.productName"/>
            </b-form-group>
            <b-form-group class="my-4" label="Country" label-for="whereCountry">
              <b-select id="whereCountry" :options="xoxodayCountryList" html-field="label" v-model="xoxodayWhere.country"/>
            </b-form-group>
            <b-form-group class="my-4" label="Category" label-for="voucherCategory">
              <b-radio-group id="voucherCategory" stacked html-field="label"
                :options="xoxodayVoucherCategoryList" v-model="xoxodayWhere.voucher_category"/>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3" v-else/>
          <b-col cols="12" md="9" v-if="$apollo.queries.browseVouchers.loading || !browseVouchers">
            <div class="d-flex justify-content-center align-items-center my-5">
              <b-spinner variant="primary"/>
            </div>
          </b-col>
          <b-col cols="12" md="9" v-else>
            <b-row v-if="browseVouchers.length">
              <b-col
                v-for="voucher in browseVouchers
                  .slice((xoxodayPage - 1) * xoxodayLimit, xoxodayPage * xoxodayLimit)
                  .filter(({ customFields }) => customFields.currencyCode)"
                :key="voucher.externalID" cols="12" sm="6" lg="4" xl="3"
              >
                <b-card class="my-4" no-body>
                  <b-card-img :src="voucher.imageURL" :alt="voucher.title" height="150px" class="img-fit-cover" top
                    v-b-modal="`modal-${voucher.externalID}`"/>
                  <b-card-body>
                    <b-card-title class="text-truncate" v-b-modal="`modal-${voucher.externalID}`">{{ voucher.title }}</b-card-title>
                    <choose-denominations v-if="voucher.customFields && voucher.customFields.valueDenominations" is-inline
                      :disabled="isDefaultIntegration"
                      :coin-balance="rewardTokensBalance"
                      :value-denominations="voucher.customFields.valueDenominations"
                      :exchangeRate="voucher.customFields.exchangeRate"
                      :currencyCode="voucher.customFields.currencyCode"
                      @claim="chosen => claimExternalReward(voucher, chosen)"/>
                  </b-card-body>
                </b-card>
                <b-modal :id="`modal-${voucher.externalID}`" :title="voucher.title" hide-footer size="xl">
                  <b-row>
                    <b-col cols="12" md="8">
                      <div class="d-flex justify-content-center align-items-center border border-radius">
                        <b-img class="border-radius my-5" :src="voucher.imageURL" :alt="voucher.title"
                          :style="{ 'max-height': '300px', width: '300px' }"/>
                      </div>
                      <b-card class="my-4" title="How to redeem/use" v-if="voucher.customFields && voucher.customFields.redemption">
                        <div class="rich-text-content" v-html="voucher.customFields.redemption"/>
                      </b-card>
                      <b-card class="my-4" title="Terms & Conditions" v-if="voucher.customFields && voucher.customFields.termsAndConditions">
                        <div class="rich-text-content" v-html="voucher.customFields.termsAndConditions"/>
                      </b-card>
                      <b-card class="my-4" :title="`About ${voucher.title}`" v-if="voucher.description">
                        <div class="rich-text-content" v-html="voucher.description"/>
                      </b-card>
                    </b-col>
                    <b-col cols="12" md="4">
                      <b-card bg-variant="light" v-if="voucher.customFields && voucher.customFields.deliveryType === 'delayed'" class="mb-3">
                        <h4>{{ $t('rewards.delay.title') }}</h4>
                        <p>{{ $t('rewards.delay.description') }}</p>
                      </b-card>
                      <b-card :title="voucher.title">
                        <choose-denominations v-if="voucher.customFields && voucher.customFields.valueDenominations"
                          :disabled="isDefaultIntegration"
                          :coin-balance="rewardTokensBalance"
                          :value-denominations="voucher.customFields.valueDenominations"
                          :exchangeRate="voucher.customFields.exchangeRate"
                          :currencyCode="voucher.customFields.currencyCode"
                          @claim="chosen => claimExternalReward(voucher, chosen)"/>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-modal>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-center align-items-center my-5" v-else>
              <p>{{ $t('rewards.no-results') }}</p>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <b-pagination v-model="xoxodayPage" :total-rows="browseVouchers.length" :per-page="xoxodayLimit"/>
            </div>
          </b-col>
        </template>

        <template v-else-if="Array.isArray(rewards) && rewards.length">
          <b-col class="pt-4 pb-3 px-3" cols="12">
            <h3>{{ $t('rewards.available') }}</h3>
          </b-col>
          <b-col class="mb-4" cols="12" sm="6" v-for="entry in rewards" :key="`reward-${entry.id}`">
            <b-card class="h-100" body-class="p-0">
              <b-media class="p-3">
                <template v-slot:aside v-if="entry.image && typeof entry.image.fileLocation === 'string'">
                  <b-img v-if="entry.image.fileLocation.endsWith('.gif')" height="128" width="128"
                    :src="entry.image.fileLocation" :alt="entry.title"/>
                  <b-img v-else height="128" width="128"
                    :src="entry.image.fileLocation | cdn('resize', 128, 128)" :alt="entry.title"/>
                </template>
                <template v-slot:aside v-else>
                  <b-img blank blank-color="#ccc" height="128" width="128"/>
                </template>
                <b-card-body class="py-2 px-3">
                  <b-card-title>{{ entry.title }}</b-card-title>
                  <b-card-text>{{ entry.description }}</b-card-text>
                </b-card-body>

                <b-card-footer class="bg-white border-0 d-flex justify-content-end align-items-center">
                  <b-btn v-if="entry.url" :href="entry.url" target="_blank" variant="outline-primary" class="mr-3">
                    {{ $t('ctas.learn-more') }} <font-awesome-icon icon="external-link-alt" size="sm"/>
                  </b-btn>
                  <b-btn @click.prevent="() => selectedClaimID = entry.id" variant="primary"
                    :disabled="(canClaimRewards && canClaimThisReward(entry)) === false">
                      {{ entry.tokenCost }} <rewards-coin/>
                  </b-btn>
                </b-card-footer>
              </b-media>
              <b-card-footer class="d-flex align-items-center" v-if="isRecruiterAdmin">
                <b-btn @click.prevent="() => selectedEditID = entry.id" variant="link">{{ $t('ctas.pencil-edit') }}</b-btn>
                <div class="flex-fill"/>
                <i18n path="general.added" tag="span">
                  <template v-slot:timeAgo>{{ entry.createdAt | timeAgo }}</template>
                </i18n>
              </b-card-footer>
            </b-card>
          </b-col>
        </template>

        <b-col cols="12" v-else>
          <b-card>
            <div class="d-flex justify-content-center align-items-center my-5">
              {{ $t('rewards.shop-unavailable1') }}<br/>{{ $t('rewards.shop-unavailable2') }}
            </div>
          </b-card>
        </b-col>
      </b-row>

      <div class="d-flex flex-row justify-content-center">
        <p><small>{{ $t('rewards.footer-text') }}</small></p>
      </div>

      <!-- Claim Reward Modal -->
      <b-modal v-if="selectedClaimID && selectedClaimEntry" visible size="md" hide-header-close hide-footer lazy
        @hidden="() => selectedClaimID = null" :title="$t('rewards.claim-reward-modal.title', { rewardTitle: selectedClaimEntry.title })">
          <b-form-group :label="selectedClaimEntry.customMessageLabel || $t('rewards.claim-reward-modal.customMessageLabel')" label-for="employeeMessage">
            <b-form-textarea id="employeeMessage" v-model="claimEmployeeMessage" rows="3" max-rows="6"
              :placeholder="selectedClaimEntry.customMessageRequired ? 'Required' : 'Optional'"/>
          </b-form-group>

          <p>Confirm below to request your reward.
            Once confirmed your claim will be verified &amp; an administrator will approve the reward.
            We will notify you when your claim is approved &amp; your reward will be sent to you by email or post, if applicable.</p>

          <b-alert v-if="!canClaimRewards" class="px-2" show variant="warning">
            {{ $t('rewards.errors.recruiters-cannot-claim') }}
          </b-alert>

          <div class="bg-white border-0 d-flex justify-content-start align-items-center">
            <b-btn class="mr-3" :disabled="isClaimEntryActionDisabled" @click.prevent="claimReward" variant="primary">
              {{ $t('rewards.ctas.claim-for-tokens', { tokenCost: selectedClaimEntry.tokenCost }) }} <rewards-coin/>
            </b-btn>
            <b-btn @click.prevent="() => selectedClaimID = null" variant="outline-danger">
              {{ $t('ctas.cancel') }}
            </b-btn>
          </div>
      </b-modal>

      <!-- Manage Claims Modal -->
      <b-modal v-if="isRecruiterAdmin" :title="$t('rewards.manage-shop')" id="recruiterList" size="xl" body-class="p-3" lazy hide-footer>
        <rewards-admin-panel />
      </b-modal>

      <!-- Edit Modal -->
      <b-modal v-if="isRecruiterAdmin" :visible="Boolean(selectedEditID)" size="md" hide-footer no-close-on-backdrop
        lazy @hidden="() => selectedEditID = null" :title="selectedEditID === 'NEW' ? 'Create Reward' : 'Edit Reward'">
          <b-form v-if="upsertRewardForm">
            <b-form-group :label="$t('rewards.labels.title')" label-for="title" label-align-sm="right" label-cols-sm="3">
              <b-input id="title" placeholder="Title" v-model="upsertRewardForm.title"/>
              <b-form-text>{{ $t('general.required') }}</b-form-text>
            </b-form-group>
            <b-form-group :label="$t('rewards.labels.description')" label-for="description" label-align-sm="right" label-cols-sm="3">
              <b-textarea id="description" no-auto-shrink no-resize rows="3" max-rows="3"
                placeholder="Set a useful description" v-model="upsertRewardForm.description"/>
            </b-form-group>
            <b-form-group :label="$t('rewards.labels.image')" label-for="image" label-align-sm="right" label-cols-sm="3">
              <asset-block :field="{ type: 'IMAGE' }" id="image" show-preview v-model="upsertRewardForm.image"/>
            </b-form-group>
            <b-form-group :label="$t('rewards.labels.url')" label-for="url" label-align-sm="right" label-cols-sm="3">
              <b-input id="url" placeholder="E.g. https://..." v-model="upsertRewardForm.url"/>
            </b-form-group>
            <hr/>
            <b-form-group :label="$t('rewards.labels.tokenCost')" label-for="tokenCost" label-align-sm="right" label-cols-sm="3">
              <b-input-group>
                <template v-slot:prepend><div class="input-group-text"><rewards-coin/></div></template>
                <b-input id="tokenCost" number :min="1" type="number" v-model="upsertRewardForm.tokenCost"/>
              </b-input-group>
              <b-form-text>{{ $t('rewards.labels.tokenCost-help') }}</b-form-text>
            </b-form-group>
            <b-form-group :label="$t('rewards.labels.totalStock')" label-for="totalStock" label-align-sm="right" label-cols-sm="3">
              <b-input-group prepend="×"><b-input id="totalStock" number :min="0" type="number" v-model="upsertRewardForm.totalStock"/></b-input-group>
              <b-form-text>{{ $t('rewards.labels.totalStock-help') }}</b-form-text>
            </b-form-group>
            <b-form-group :label="$t('rewards.labels.availablity')" label-align-sm="right" label-cols-sm="3">
              <date-picker class="mb-2" format="YYYY-MM-DD hh:mm:ss" lang="en" placeholder="Available From" type="datetime" v-model="upsertRewardForm.availableFrom"/>
              <date-picker format="YYYY-MM-DD hh:mm:ss" lang="en" placeholder="Available Until" type="datetime" v-model="upsertRewardForm.availableUntil"/>
              <b-form-text>{{ $t('rewards.labels.availablity-help') }}</b-form-text>
            </b-form-group>
            <b-form-group :label="$t('rewards.labels.oneTimeClaim')" label-for="oneTimeClaim" label-align-sm="right" label-cols-sm="3">
              <b-form-checkbox class="pt-sm-1" id="oneTimeClaim" plain v-model="upsertRewardForm.oneTimeClaim" :value="true" :unchecked-value="false">
                {{ $t('rewards.labels.oneTimeClaim-help') }}
              </b-form-checkbox>
              <b-form-text>{{ $t('rewards.labels.oneTimeClaim-useful') }}</b-form-text>
            </b-form-group>
            <hr/>
            <b-form-group :label="$t('rewards.labels.customMessageLabel')" label-for="customMessageLabel" label-align-sm="right" label-cols-sm="3">
              <b-input id="customMessageLabel" placeholder="Message" v-model="upsertRewardForm.customMessageLabel"/>
              <b-form-text>{{ $t('rewards.labels.customMessage-help') }}</b-form-text>
            </b-form-group>
            <b-form-group label="" label-align-sm="right" label-cols-sm="3">
              <b-form-checkbox id="customMessageRequired" plain v-model="upsertRewardForm.customMessageRequired"
                :value="true" :unchecked-value="false">
                  {{ $t('rewards.labels.customMessage-required') }}
              </b-form-checkbox>
            </b-form-group>
            <hr/>
            <b-form-group label="Status" label-for="url" label-align-sm="right" label-cols-sm="3">
              <b-form-select :options="rewardStatusOptions" v-model="upsertRewardForm.status"/>
            </b-form-group>
            <b-form-group label-cols-sm="3">
              <div class="d-flex flex-row">
                <b-btn class="mr-2" @click="saveReward" variant="primary">
                  <template v-if="selectedEditID === 'NEW'">{{ $t('ctas.create-new') }}</template>
                  <template v-else>{{ $t('ctas.save-changes') }}</template>
                </b-btn>
                <b-btn variant="outline-danger" @click="() => selectedEditID = null">
                  <template v-if="selectedEditID === 'NEW'">{{ $t('ctas.cancel') }}</template>
                  <template v-else>{{ $t('ctas.discard-changes') }}</template>
                </b-btn>
              </div>
            </b-form-group>
          </b-form>
      </b-modal>

    </template>
  </div>
</template>

<script>
import _startCase from 'lodash/startCase';
import gql from 'graphql-tag';
import ContentEditable from '@src/components/misc/ContentEditable';
import ChooseDenominations from '@src/components/rewards/ChooseDenominations';
import RewardTokensHistoryCard from '@src/components/rewards/RewardTokensHistory';
import HowToEarnTokensCard from '@src/components/rewards/HowToEarnTokens';
import ClaimedRewardsCard from '@src/components/rewards/ClaimedRewards';
import RewardsAdminPanel from '@src/components/rewards/RewardsAdmin';
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import UserClaimedRewardDetailsFragment from '@src/graphql/fragments/UserClaimedRewardDetails.gql';
import ListRewardsQuery from '@src/graphql/queries/ListRewards.gql';
import BrowseRewardsQuery from '@src/graphql/queries/BrowseRewards.gql';
import distanceInWords from 'date-fns/distance_in_words';
import gridMixin from '@src/mixins/grid';
import UnderMaintenance from '@src/components/misc/UnderMaintenance';
import { RewardsCoin } from '@src/components/Icons';
import { mapRoot, mapPreferences } from '@src/mixins/root';
import RewardDetailsFragment from '@src/graphql/fragments/RewardDetails.gql';

const RewardManageDetailsFragment = gql`
  fragment RewardManageDetails on Reward {
    customMessageLabel
    customMessageRequired
    internalCost
    availableStock
    totalStock
    availableFrom
    availableUntil
  }
`;

const CreateRewardMutation = gql`
  mutation CreateReward($data: CreateRewardInput!) {
    createReward(create: $data) {
      ...RewardDetails
      ...RewardManageDetails
    }
  }
  ${RewardDetailsFragment}
  ${RewardManageDetailsFragment}
`;

const UpdateRewardMutation = gql`
  mutation UpdateReward($id: ID!, $data: UpdateRewardInput!) {
    updateReward(update: $data, where: { id: $id }) {
      ...RewardDetails
      ...RewardManageDetails
    }
  }
  ${RewardDetailsFragment}
  ${RewardManageDetailsFragment}
`;

export default {
  mixins: [
    gridMixin,
  ],
  components: {
    AssetBlock: () => import('@/components/settings/AssetBlock'),
    ContentEditable,
    ClaimedDescription: () => import('@src/components/rewards/ClaimedDescription'),
    DatePicker: () => import('vue2-datepicker'),
    RewardsProgressBar: () => import('@/components/rewards/Progress'),
    RewardsCoin,
    ChooseDenominations,
    UnderMaintenance,
    LoadingSpinner,
    RewardTokensHistoryCard,
    HowToEarnTokensCard,
    ClaimedRewardsCard,
    RewardsAdminPanel,
  },
  data: () => ({
    err: null,
    form: null,
    upsertRewardForm: null,
    canClaimRewards: false,
    selectedClaimID: null,
    selectedEditID: null,
    rewardTokensBalance: null,
    rewardTokensTotal: null,
    claimEmployeeMessage: null,
    outstandingRewards: null,
    claimedRewards: null,
    rewardScheme: null,
    rewardScores: null,
    rewardTokensHistory: null,
    selectedClaimedRewards: [],
    manageClaimedRewards: null,
    xoxodayFilters: null,
    xoxodayWhere: {
      country: 'uk',
      productName: null,
      // deliveryType: 'realtime',
      // voucher_category: null, // NOT SUPPORTED
    },
    xoxodayPage: 1,
    xoxodayLimit: 12,
    xoxodayIntegrationID: null,
    loading: false,
    rewardClaimIsUpdating: false,
  }),
  mounted() {
    this.xoxodayWhere.country = this.defaultRewardsLocale || 'uk';
    this.$apollo.queries.browseVouchers.start();
  },
  metaInfo() {
    const meta = {
      title: this.$t('rewards.title'),
    };

    if (this.selectedEditID) {
      meta.title = this.$t(this.selectedEditID === 'NEW' ? 'rewards.ctas.create-reward' : 'rewards.ctas.update-reward');
    }

    return meta;
  },
  apollo: {
    browseVouchers: {
      query: BrowseRewardsQuery,
      variables() {
        const { xoxodayWhere: where } = this;
        /* eslint-disable object-property-newline */
        return {
          integration: { provider: 'xoxoday-plum' },
          // withFilters: this.xoxodayFilters === null,
          where, order: 'product_name', page: 1, limit: 120,
        };
      },
      update({ browseRewardsVendor }) {
        const { vouchers } = browseRewardsVendor || {};
        return Array.isArray(vouchers) ? vouchers : [];
      },
      result({ loading, data }) {
        if (!loading && data && data.browseRewardsVendor) {
          const { integration, filters } = data.browseRewardsVendor;
          if (integration && integration.id) {
            this.xoxodayIntegrationID = integration.id;
          }
          if (Array.isArray(filters) && filters.length) {
            this.xoxodayFilters = filters;
          }
        }
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      debounce: 2000,
      deep: true,
      skip: true,
    },
    rewards: {
      query: ListRewardsQuery,
      variables() {
        const where = {
          isAvailableNow: this.isRecruiterAdmin ? null : true,
          status: 'ACTIVE',
        };

        return { where, isRecruiter: this.isRecruiter };
      },
      update: ({ company: { rewards } }) => rewards || [],
      result({ loading, data }) {
        if (!loading && data && data.company) {
          const { rewardScheme, rewardScores } = data.company;
          this.rewardScheme = rewardScheme ? { ...rewardScheme } : null;
          this.rewardScores = rewardScores ? [ ...rewardScores ] : null;

          if (this.isRecruiter) {
            const { claimedRewards, preferences } = data.company;
            this.manageClaimedRewards = Array.isArray(claimedRewards) ? claimedRewards : [];

            const { canRecruitersClaimRewards } = preferences || {};
            this.canClaimRewards = canRecruitersClaimRewards === true;
          } else {
            this.canClaimRewards = true;
          }

          if (data.user) {
            const { rewardTokensBalance, rewardTokensTotal, outstandingRewards, claimedRewards, rewardTokensHistory } = data.user || {};

            console.log({ claimedRewards });

            this.rewardTokensBalance = parseInt(rewardTokensBalance, 10) || 0;
            this.rewardTokensTotal = parseInt(rewardTokensTotal, 10) || 0;
            this.outstandingRewards = Array.isArray(outstandingRewards) ? outstandingRewards : [];
            this.claimedRewards = Array.isArray(claimedRewards) ? claimedRewards : [];
            this.rewardTokensHistory = Array.isArray(rewardTokensHistory) ? rewardTokensHistory : [];
            console.log({ rewardTokenHistory: this.rewardTokensHistory });
          }
        }
      },
      error(err) {
        this.err = err;
      },
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isRecruiter', 'isRecruiterAdmin', 'isVoltaTrucks', 'isSuperAdmin', 'isEnglishLang', 'isAssurant', 'isStoryblok' ]),
    ...mapPreferences([ 'defaultRewardsLocale' ]),
    quantities() {
      return Array.from(Array(50)).map((v, i) => i + 1);
    },
    xoxodayCountryList() {
      const { values } = Array.isArray(this.xoxodayFilters)
        ? this.xoxodayFilters.find(f => f && f.externalID === 'country')
        : {};
      return Array.isArray(values) ? values : [];
    },
    xoxodayVoucherCategoryList() {
      const { values } = Array.isArray(this.xoxodayFilters)
        ? this.xoxodayFilters.find(f => f && f.externalID === 'voucher_category')
        : {};
      return Array.isArray(values) ? values
        .filter(el => el.label)
        .map(
          el => {
            el.label = el.label = el.label.replaceAll('_', ' ');
            el.label = el.label.toLowerCase().charAt(0).toUpperCase() + el.label.slice(1);
            return el;
          }
        ) : [];
    },
    isDefaultIntegration() {
      return this.xoxodayIntegrationID === 'DEFAULT-XOXODAY-BROWSE-INTEGRATION';
    },
    // internalCostCurrency() {
    //   // const { handle } = this.company || {};
    //   // return handle === 'optiver' ? '€' : '£';
    //   return 'Coin';
    // },
    selectedClaimEntry() {
      return (Array.isArray(this.rewards) && this.selectedClaimID)
        ? this.rewards.find(r => r && r.id === this.selectedClaimID)
        : null;
    },
    isClaimEntryActionDisabled() {
      if (this.canClaimRewards && this.selectedClaimEntry) {
        const { customMessageRequired } = this.selectedClaimEntry;
        const { claimEmployeeMessage } = this;
        return customMessageRequired && !claimEmployeeMessage;
      } else {
        return true;
      }
    },
    selectedEditEntry() {
      return (Array.isArray(this.rewards) && this.selectedEditID)
        ? this.rewards.find(r => r && r.id === this.selectedEditID)
        : null;
    },
    rewardStatusOptions: () => ({
      ACTIVE: 'Active',
      INACTIVE: 'Disabled',
      DELETED: 'Deleted',
    }),
    rewardSchemeCounts() {
      const { rewardTokensHistory: history } = this;
      return Object.keys(this.rewardScheme || {}).reduce((r, key) => {
        const claims = Array.isArray(history) ? history.filter(({ eventName }) => key === eventName) : [];
        return { ...r, [key]: claims.length };
      }, []);
    },
    manageClaimFields() {
      return [
        { key: 'id', label: '', thStyle: 'width:20px;' },
        { key: 'rewardData.title', label: 'Reward Voucher' },
        { key: 'user.fullName', label: 'User' },
        { key: 'createdAt', label: 'Claimed At' },
        { key: 'updatedAt' },
        { key: 'status', formatter: value => _startCase(`${value}`.toLowerCase()) },
        { key: 'opts', label: '', thStyle: 'width:20px;' },
      ];
    },
    manageClaimStatuses() {
      return {
        REQUESTED: [
          { label: this.$t('rewards.status-changes.REQUESTED.current'), status: 'REQUESTED', disabled: true },
          { label: this.$t('rewards.status-changes.VERIFIED.forward'), status: 'VERIFIED', default: true, variant: 'success' },
          { label: this.$t('rewards.status-changes.APPROVED.forward'), status: 'APPROVED' },
          { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', variant: 'danger' },
        ],
        VERIFIED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED' },
          { label: this.$t('rewards.status-changes.VERIFIED.current'), status: 'VERIFIED', disabled: true },
          { label: this.$t('rewards.status-changes.APPROVED.forward'), status: 'APPROVED', default: true, variant: 'success' },
          { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', variant: 'danger' },
        ],
        APPROVED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED' },
          { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.current'), status: 'APPROVED', disabled: true },
          { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED', default: true, variant: 'success' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', variant: 'danger' },
        ],
        FULFILLED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED' },
          { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.back'), status: 'APPROVED' },
          { label: this.$t('rewards.status-changes.FULFILLED.current'), status: 'FULFILLED', default: true, disabled: true, variant: 'outline-primary' },
          { label: this.$t('rewards.status-changes.REJECTED.forward'), status: 'REJECTED', variant: 'danger' },
        ],
        REJECTED: [
          { label: this.$t('rewards.status-changes.REQUESTED.back'), status: 'REQUESTED', variant: 'success' },
          { label: this.$t('rewards.status-changes.VERIFIED.back'), status: 'VERIFIED' },
          { label: this.$t('rewards.status-changes.APPROVED.back'), status: 'APPROVED' },
          { label: this.$t('rewards.status-changes.FULFILLED.forward'), status: 'FULFILLED', variant: 'warning' },
          { label: 'Rejected', status: 'REJECTED', default: true, disabled: true, variant: 'outline-danger' },
        ],
      };
    },
  },
  methods: {
    canClaimThisReward({ id: rewardID, tokenCost, oneTimeClaim }) {
      const { rewardTokensBalance, claimedRewards } = this;

      if (oneTimeClaim && Array.isArray(claimedRewards) && claimedRewards.find(c => c && c.reward && c.reward.id === rewardID)) {
        return false;
      }

      return rewardTokensBalance >= tokenCost;
    },
    async claimReward() {
      try {
        const { claimEmployeeMessage: employeeMessage, selectedClaimEntry: reward } = this;
        this.$assert(reward && reward.id, new Error('Reward not found'), { where: { id: this.selectedClaimID } });
        this.$assert(this.canClaimThisReward(reward), new Error('Sorry, you cannot claim this reward'));
        this.$assert(!reward.customMessageRequired || employeeMessage, new Error('You must enter a custom message'));

        const query = this.$options.apollo.rewards.query;
        const variables = this.$options.apollo.rewards.variables.call(this);

        const create = {
          reward: { id: this.selectedClaimID },
          user: { self: true },
          employeeMessage,
        };

        this.loading = true;
        await this.$apollo.mutate({
          mutation: gql`
            mutation CreateClaimedReward($create: CreateClaimedRewardInput!) {
              createClaimedReward(create: $create) {
                ...UserClaimedRewardDetails
              }
            }
            ${UserClaimedRewardDetailsFragment}
          `,
          variables: { create },
          update(store, { data: { createClaimedReward: claimed } }) {
            const data = store.readQuery({ query, variables });

            if (data && data.user && Array.isArray(data.user.claimedRewards)) {
              data.user.claimedRewards.unshift(claimed);
            }

            store.writeQuery({ query, variables, data });
          },
        });

        this.loading = false;
        this.selectedClaimID = null;
      } catch (err) {
        this.loading = false;
        this.$notifyErr(err);
      }
    },
    async claimExternalReward(voucher, { denomination, quantity, tokenCost }) {
      try {
        this.$assert(!this.isDefaultIntegration, 'Cannot claim an external reward on the default integration');
        this.$assert(voucher && voucher.externalID, 'Missing externalID');
        this.$assert(typeof denomination === 'number', 'Missing denomination');
        this.$assert(typeof quantity === 'number', 'Missing quantity');
        this.$assert(typeof tokenCost === 'number', 'Missing tokenCost');

        const { rewardTokensBalance } = this;
        this.$assert(rewardTokensBalance >= tokenCost, 'You do not have enough coins to ');

        const { xoxodayIntegrationID: integrationID } = this;
        const { externalID, title, imageURL } = voucher;
        const { exchangeRate, currencyCode } = voucher.customFields || {};

        const create = {
          user: { self: true },
          rewardData: {
            integrationID, externalID, title, imageURL,
            denomination, quantity, tokenCost, exchangeRate,
            currencyCode
          },
        };

        this.$log.debug({
          voucher,
          chosen: { denomination, quantity, tokenCost },
          create,
        });

        this.loading = true;
        await this.$apollo.mutate({
          mutation: gql`
            mutation ClaimExternalReward($create: CreateClaimedRewardInput!) {
              createClaimedReward(create: $create) {
                ...UserClaimedRewardDetails
              }
            }
            ${UserClaimedRewardDetailsFragment}
          `,
          variables: { create },
          update: (store, { data: { createClaimedReward: claimed } }) => {
            const query = this.$options.apollo.rewards.query;
            const variables = this.$options.apollo.rewards.variables.call(this);

            const data = store.readQuery({ query, variables });

            if (data && data.user && Array.isArray(data.user.claimedRewards)) {
              data.user.rewardTokensBalance -= tokenCost;
              data.user.claimedRewards.unshift(claimed);
            }

            store.writeQuery({ query, variables, data });
          },
        });
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$log.error(err);
      }
    },
    async updateClaimedReward(rewardID, update) {
      this.rewardClaimIsUpdating = true;
      try {
        this.$assert(this.isRecruiter, 'Only recruiters can perform this action');
        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateClaimedReward($update: UpdateClaimedRewardInput!, $rewardID: ID!) {
              updateClaimedReward(update: $update, where: { id: $rewardID }) {
                id
                status
              }
            }
          `,
          variables: {
            update,
            rewardID,
          },
        });

        this.$notification({
          message: 'Claimed reward updated',
          variant: 'success',
        });
      } catch (err) {
        this.$notifyErr(err);
      }
      this.rewardClaimIsUpdating = false;
    },
    selectClaimedReward(rewardID, checked) {
      const exists = this.selectedClaimedRewards.includes(rewardID);
      if (!exists && checked) {
        this.selectedClaimedRewards.push(rewardID);
      } else if (exists && !checked) {
        this.selectedClaimedRewards.splice(this.selectedClaimedRewards.indexOf(rewardID), 1);
      }
    },
    async updateManyClaimedRewards(update) {
      try {
        this.$assert(this.isRecruiter, 'Only recruiters can perform this action');
        this.$assert(this.selectedClaimedRewards.length, 'No items are selected');

        await this.$apollo.mutate({
          mutation: gql`
            mutation UpdateClaimedReward($update: UpdateClaimedRewardInput!, $rewardIDs: [ ID! ]!) {
              updateManyClaimedRewards(update: $update, where: { id_in: $rewardIDs }) {
                id
                status
              }
            }
          `,
          variables: {
            update,
            rewardIDs: this.selectedClaimedRewards,
          },
        });

        this.$notification({
          message: 'Claimed rewards updated',
          variant: 'success',
        });
      } catch (err) {
        this.$notifyErr(err);
      }
    },
    async saveReward() {
      try {
        const data = JSON.parse(JSON.stringify(this.upsertRewardForm));
        this.$log.debug(data);

        const { selectedEditID } = this;
        const { title, tokenCost, totalStock } = data;
        this.$assert(typeof title === 'string' && title.length, new Error('Missing required Title'));
        this.$assert(typeof tokenCost === 'number' && tokenCost > 0, new Error('Missing required Token Cost'));
        this.$assert(typeof totalStock === 'number', new Error('Missing required Available Stock'));

        data.image = data.image && data.image.id ? { id: data.image.id } : null;

        const query = this.$options.apollo.rewards.query;
        const variables = this.$options.apollo.rewards.variables.call(this);

        await this.$apollo.mutate({
          mutation: selectedEditID === 'NEW' ? CreateRewardMutation : UpdateRewardMutation,
          variables: { id: selectedEditID === 'NEW' ? undefined : selectedEditID, data },
          update(store, { data: { [selectedEditID === 'NEW' ? 'createReward' : 'updateReward']: reward } }) {
            const data = store.readQuery({ query, variables });

            if (data && data.company && Array.isArray(data.company.rewards)) {
              if (selectedEditID === 'NEW') {
                data.company.rewards.push(reward);
              } else {
                const i = data.company.rewards.findIndex(r => r && r.id === selectedEditID);
                data.company.rewards.splice(i, i >= 0 ? 1 : 0, reward);
              }
            }

            store.writeQuery({ query, variables, data });
          },
        });

        this.$notification({
          title: selectedEditID === 'NEW' ? 'Reward created' : 'Reward updated',
          message: selectedEditID === 'NEW' ? `Successfully created the ${title} reward` : `Successfully updated the ${title} reward`,
          variant: 'success',
        });

        this.selectedEditID = null;
      } catch (err) {
        this.$notifyErr(err);
      }
    },
  },
  filters: {
    timeAgo(createdAt) {
      return distanceInWords(new Date(), createdAt, { addSuffix: true });
    },
  },
  watch: {
    selectedClaimID() {
      this.claimEmployeeMessage = null;
    },
    selectedEditID(id) {
      /* eslint-disable object-property-newline */
      if (id === 'NEW') {
        this.upsertRewardForm = { tokenCost: 10, totalStock: 1, status: 'ACTIVE' };
      } else if (this.selectedEditEntry) {
        const {
          title, description, image, url, tokenCost, internalCost, totalStock, oneTimeClaim,
          availableFrom, availableUntil, customMessageLabel, customMessageRequired, status,
        } = this.selectedEditEntry;
        this.upsertRewardForm = {
          title, description, image, url, tokenCost, internalCost, totalStock, oneTimeClaim,
          availableFrom, availableUntil, customMessageLabel, customMessageRequired, status,
        };
      } else {
        this.upsertRewardForm = null;
      }
    },
  },
  browseVouchers() {
    console.log('Browse voucher: ', this.browseVouchers);
  },
};
</script>

<style lang="scss">
.rewards-browser {
  table {
    table-layout: fixed;

    th,td {
      text-align: center;
    }
  }

  .modal#recruiterList {
    .reward-detail-actions {
      .dropdown > .btn:not(.dropdown-toggle) {
        width: 100%;
      }
    }
  }
}

.modal-content {
  min-height: 60vh;

  table {
    min-height: 60vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/User/RewardsBrowser.vue